export const validateTextNormal = (value) => {
    const regex = /^[a-zA-Z0-9(), \-\b.@/]*$/; // Menambahkan karakter / ke regex
    return regex.test(value);
};
export const validateAngkaNormal = (value) => {
    const regex = /^[0-9\b]*$/; // Hanya angka, backspace, dan delete diperbolehkan
    return regex.test(value);
};
export const validateAngkaTitik = (value) => {
    const regex = /^[0-9,.\b]*$/; // Allow digits, comma, dot, backspace, and delete
    return regex.test(value);
};

export const validateTextCode = (value) => {
    const regex = /^[a-zA-Z0-9\b]*$/; // Hanya karakter huruf besar, huruf kecil, angka, delete, dan backspace yang diperbolehkan
    return regex.test(value);
};

export const validateLicensePlate = (value) => {
    // AA1234XXX
    // A1234XXX
    const PatternStep0 = /^[\b]*$/;
    const PatternStep1 = /^[abdefghklmnprstwzABDEFGHKLMNPRSTWZ\b]*$/;
    const PatternStep2 = /^[adblkmhgnefzrtucADBLKMHGNEFZRTUC0-9\b]*$/;
    const PatternStep3 = /^[0-9\b]*$/;
    const PatternStep4 = /^[a-zA-Z\b]*$/;
    if (value.length === 1){
        return PatternStep1.test(value.substring(0, 1));
    }else if (value.length === 2){
        return PatternStep2.test(value.substring(1, 2));
    }else if (value.length === 3){
        return PatternStep3.test(value.substring(2, 3));
    }else if (value.length === 4){
        return PatternStep3.test(value.substring(3, 4));
    }else if (value.length === 5){
        return PatternStep3.test(value.substring(4, 5));
    }else if (value.length === 6){
        return (PatternStep3.test(value.substring(5, 6)) || PatternStep4.test(value.substring(5, 6)));
    }else if (value.length === 7){
        return PatternStep4.test(value.substring(6, 7));
    }else if (value.length === 8){
        return PatternStep4.test(value.substring(7, 8));
    }else if (value.length === 9) {
        return PatternStep4.test(value.substring(8, 9));
    }else{
        return PatternStep0.test(value);
    }

};

export const validateEmail = (email) => {
    const regex = /^[a-zA-Z0-9_\-@.]+$/;
    // Mengizinkan email kosong atau sesuai dengan ekspresi reguler
    return email === '' || regex.test(email);
};





